// Libraries
import { Box, Skeleton } from "@mui/material";
import clsx from "clsx";

// Layouts
import Button from "@/Layouts/components/Buttons/Button";

type TTitlePositionSelectorProps = {
	activeOption: number;
	positions: string[];
	isLoading: boolean;
	onChangePosition: (index: number) => void;
};

export default function TitlePositionSelector(props: Readonly<TTitlePositionSelectorProps>) {
	const { isLoading, activeOption, positions, onChangePosition } = props;

	if (isLoading) {
		return (
			<Box display="flex" justifyContent="center" mt={4} mb={1}>
				<Skeleton variant="rectangular" height={30} width={134} className="rounded-md !mx-3" />
				<Skeleton variant="rectangular" height={30} width={134} className="rounded-md !mx-3" />
				<Skeleton variant="rectangular" height={30} width={134} className="rounded-md !mx-3" />
			</Box>
		);
	}

	return (
		<Box display="flex" justifyContent="center" mt={4} mb={1}>
			{positions.map((position, index) => (
				<Button
					key={position}
					variant="outlined"
					text={position}
					classes={clsx({
						"!bg-transparent !text-default !font-montserrat !font-medium !text-[12px] !normal-case": true,
						"!mx-3 !rounded-md": true,
						"h-[30px] w-[134px]": true,
						"!border-primary !shadow-selector-paper-shadow": activeOption === index,
						"!border-disabled": activeOption !== index,
					})}
					onClick={() => onChangePosition(index)}
				/>
			))}
		</Box>
	);
}
